const SET_FEATUREDPAGE_DATA = 'SET_FEATUREDPAGE_DATA';
const SET_COLLECTIONSPAGE_DATA = 'SET_COLLECTIONSPAGE_DATA';
const SET_COLLECTIONPAGE_DATA = 'SET_COLLECTIONPAGE_DATA';
const SET_POSTSPAGE_DATA = 'SET_POSTSPAGE_DATA';
const SET_POSTSDIRECTORYPAGE_DATA = 'SET_POSTSDIRECTORYPAGE_DATA';
const SET_POSTPAGE_DATA = 'SET_POSTPAGE_DATA';
const SET_PRODUCTSPAGE_DATA = 'SET_PRODUCTSPAGE_DATA';
const SET_CREATOR_PROFILE_DATA = 'SET_CREATOR_PROFILE_DATA';
const SET_UPDATED_PRODUCT_DATA = 'SET_UPDATED_PRODUCT_DATA';
const SET_UPDATED_COLLECTION_PRODUCT_DATA = 'SET_UPDATED_COLLECTION_PRODUCT_DATA';
const SET_CURRENT_TAB = 'SET_CURRENT_TAB';

const CSF_PAGE_TYPES = {
    FEATURED: 'featured',
    COLLECTIONS: 'collections',
    COLLECTION: 'collection', // Singular for collection specific page
    PRODUCTS: 'products',
    POSTS: 'posts',
    POST: 'post',
    PROFILE: 'profile'
};

export {
    SET_FEATUREDPAGE_DATA,
    SET_COLLECTIONSPAGE_DATA,
    SET_COLLECTIONPAGE_DATA,
    SET_POSTSPAGE_DATA,
    SET_POSTSDIRECTORYPAGE_DATA,
    SET_POSTPAGE_DATA,
    SET_PRODUCTSPAGE_DATA,
    SET_CREATOR_PROFILE_DATA,
    CSF_PAGE_TYPES,
    SET_UPDATED_PRODUCT_DATA,
    SET_UPDATED_COLLECTION_PRODUCT_DATA,
    SET_CURRENT_TAB
};
